// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// Import CSS
import "../css/index.css";

// Import JS
import menuOpen from "./menuOpen";
import infiniteScroll from "./infiniteScroll";
import dynamicDropdown from "./dropdown";
import handleFormSubmission from './form';

const form = document.querySelector('[data-send]');
if (form) {
 form.addEventListener('submit', handleFormSubmission);
}


// Call the menu and infinite scroll functions
menuOpen();
infiniteScroll();
dynamicDropdown();

document.addEventListener('DOMContentLoaded', function() {
    document.documentElement.classList.add('js-loaded');
});